import { lang } from 'src/utils';

export const GLOBAL_SETTINGS_LABELS = {
  customizedOutageConfig: 'Back soon styling',
  nutrition: lang.calories,
  outageStrategy: lang.outageType,
  productPriceCalorieSeparator: 'Show pipe divider between price and calories',
  productPriceCurrency: 'Currency',
  productPriceCurrencyPosition: 'Currency position',
  productPriceDecimalSeparator: 'Pricing separator',
  productPriceSeparator: 'Show pipe divider between products and prices',
  productPriceSoldoutSticker: lang.outageStyling,
  showGlobalProductDisclaimer: 'Product disclaimer',
  showZeroPrices: 'Hide 0.00 pricing',
  currencySpace: lang.currenySpaceLabel,
};
